import request from '@/utils/request';


let server = {
  listOfGoods: '/goods', // 商品列表
  listOfGoodsDetail: '/goods', // 商品详情
};


//  商品列表
export function listOfGoods(page) {
	return request({
    	url: server.listOfGoods + '?include=gallery&page=' + page,
	    method: 'get',
  	})
}


//  商品列表
export function listOfGoodsDetail(goods) {
	return request({
    	url: server.listOfGoodsDetail + '/' + goods + '?include=gallery',
	    method: 'get',
  	})
}









// WEBPACK FOOTER //
// ./src/api/goods.js